import * as React from 'react';
import * as aboutPeople from './aboutPeople.module.scss';

export const AboutPeople = ({ data, sectionClassName, container, title, titleClassName, bottomText, bottomTextClassName }) => {
  return (
    <section className={sectionClassName || aboutPeople.aboutPeople}>
      <div className={container || "container"}>
        <h2 className={titleClassName || aboutPeople.aboutPeople__title}>{title}</h2>
        <div className={aboutPeople.aboutPeople__list}>
          {data.map((elem, index) => (
            <div className={`col-12 col-md-6 ${aboutPeople.aboutPeople__col}`} key={index}>
              <img className={aboutPeople.aboutPeople__img} src={elem.imageSrc} alt={elem.name} />
              <div className={aboutPeople.aboutPeople__wrapper}>
                <h3 className={aboutPeople.aboutPeople__heading}>{elem.name}</h3>
                <p className={aboutPeople.aboutPeople__text}>{elem.descr}</p>
              </div>
            </div>
          ))}
        </div>
        <p className={bottomTextClassName || aboutPeople.aboutPeople__bottomText}>{bottomText}</p>
      </div>
    </section>
  );
};
